import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { motion, AnimatePresence } from "framer-motion";
import pccmlogo from "../assets/pccm_logo.png";
import "../styles/Navbar.css";

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const toggleMenu = () => setIsOpen(!isOpen);

  // Simplified NavLinks as requested (Consolidated)
  const navLinks = [
    { title: "Home", path: "/#top" },
    { title: "About Us", path: "/#about" },
    { title: "Leadership", path: "/#leadership" },
    { title: "Events", path: "/#events" },
    { title: "Gallery", path: "/gallery", isPage: true },
    { title: "Spaces", path: "/spaces", isPage: true },
    { title: "Contact", path: "/contact", isPage: true },
  ];

  return (
    <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="container nav-container">
        <HashLink smooth to="/#top" className="nav-logo">
          <img src={pccmlogo} alt="PCCM Logo" />
          <span className="logo-text">PCCM</span>
        </HashLink>

        {/* Desktop Menu */}
        <div className="nav-links desktop-only">
          {navLinks.map((link) => (
             link.isPage ? (
               <NavLink key={link.title} to={link.path} className={({ isActive }) => (isActive ? "active" : "")}>
                 {link.title}
               </NavLink>
             ) : (
               <HashLink key={link.title} smooth to={link.path}>
                 {link.title}
               </HashLink>
             )
          ))}
          <NavLink to="/donate" className="btn btn-primary btn-sm">
            Donate
          </NavLink>
        </div>

        {/* Mobile Toggle */}
        <div className="mobile-toggle" onClick={toggleMenu}>
          <div className={`hamburger ${isOpen ? "open" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "100vh" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="mobile-links">
              {navLinks.map((link) => (
                 link.isPage ? (
                   <NavLink key={link.title} to={link.path} onClick={toggleMenu}>
                     {link.title}
                   </NavLink>
                 ) : (
                   <HashLink key={link.title} smooth to={link.path} onClick={toggleMenu}>
                     {link.title}
                   </HashLink>
                 )
              ))}
              <NavLink to="/constitution" onClick={toggleMenu}>Constitution</NavLink>
              <NavLink to="/report" onClick={toggleMenu}>Finance</NavLink>
              <NavLink to="/memberships" onClick={toggleMenu}>Memberships</NavLink>
              <NavLink to="/advertise" onClick={toggleMenu}>Advertise</NavLink>
              
              <NavLink to="/donate" className="btn btn-primary mobile-donate" onClick={toggleMenu}>
                Donate
              </NavLink>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}

export default Navbar;
